import { storyblokEditable } from "gatsby-source-storyblok"

import VideoBanner from "../../../V2/Banners/VideoBanner"

import { storyblokLinkToYocoLink } from "@utils/storyblok"
import React from "react"

const StoryblokVideoBanner = ({
  blok,
}: Storyblok.BlokProps<Storyblok.VideoBanner>) => {
  return (
    <VideoBanner
      title={blok.title}
      description={blok.description}
      layoutStyle={blok.layoutStyle}
      backgroundImage={blok.backgroundImage.filename}
      backgroundImageAlt={blok.backgroundImage.alt}
      backgroundVideo={storyblokLinkToYocoLink(blok.backgroundVideoUrl)?.url}
      desktopCardColor={blok.desktopCardColor}
      mobileCardColor={blok.mobileCardColor}
      ctaText={blok.ctaText}
      ctaLink={blok.ctaLink}
      ctaStyle={blok.ctaStyle}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokVideoBanner
